export default {
  // 備忘錄
  memo: {
    createTiem: '創建時間',
    creater: '創建人',
    allMemo: '全部備忘',
    myCreate: '我創建的',
    shareMe: '共享給我',
    deleted: '已刪除',
    thoroughDel: '徹底刪除',
    outShare: '退出共享',
    resumeMemo: '恢復備忘',
    remind: '提醒',
    addMemo: '新增備忘',
    editMemo: '編輯備忘',
    areYouSure: '你確定要',
    term: '項備忘',
    noData: '您還沒有添加備忘錄',
    nowAdd: '現在就寫備忘',
    share: '共享',
    cc: '抄送',
    selectReminderTime: '選擇提醒時間',
    RemindYourselfOnly: '僅提醒自己',
    selectRelationship: '選擇關聯關系',
    selectedAddress: '請至少選定壹個地址',
    addressAlreadyExists: '該地址已存在',
    dataAlreadyAssociated: '已關聯該數據',
    pleaseSelectAssociatedData: '請選擇關聯數據',
    reminderTimeCannotBeEmpty: '提醒時間不能為空',
    time_error: '提醒時間不可早於當前時間',
    conten_empty: '內容不能為空',
    apply: '應用',
    seachValue: '請搜索內容'
  }
}
